import { render } from "./WCCustomSelect.vue?vue&type=template&id=da996cf6&scoped=true"
import script from "./WCCustomSelect.vue?vue&type=script&lang=js"
export * from "./WCCustomSelect.vue?vue&type=script&lang=js"

import "./WCCustomSelect.vue?vue&type=style&index=0&id=da996cf6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da996cf6"]])

export default __exports__